var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "myskov-area__content" },
    [
      _vm.page == "login"
        ? _c("login", {
            on: { forgetpw: _vm.gotoForgetPw, newaccount: _vm.gotoNewAccount }
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.page == "new-user" ? _c("new-user") : _vm._e(),
      _vm._v(" "),
      _vm.page == "forgotpw" ? _c("forget-pw") : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-fb1ee8e4", { render: render, staticRenderFns: staticRenderFns })
  }
}